import { normalizeCtaUrl } from '../../../lib/useCaseSanity';
import type { UcPricingCalloutSection } from '../../../lib/useCaseQueries';
import { UseCaseBand } from '../primitives';
import { UseCaseSectionHead } from '../UseCaseSectionHead';

type UcPricingCalloutSectionProps = {
  data: UcPricingCalloutSection;
  tone: 'light' | 'dark';
};

export function UcPricingCalloutSection({ data, tone }: UcPricingCalloutSectionProps) {
  const href = data.ctaUrl ? normalizeCtaUrl(data.ctaUrl) : undefined;
  const isExternal = href?.startsWith('http') ?? false;

  return (
    <UseCaseBand tone={tone} className="tight" id="pricing">
      <div className="content-measure pricing-callout reveal">
        <UseCaseSectionHead eyebrow={data.eyebrow} heading={data.heading} />
        {data.body && <p>{data.body}</p>}
        {data.ctaLabel && href && (
          <a
            href={href}
            className="link-tertiary"
            {...(isExternal ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
          >
            {data.ctaLabel}
          </a>
        )}
      </div>
    </UseCaseBand>
  );
}
